export default __webpack_public_path__ + "static/media/1.18c72bf7.png";